import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header-messages" }
const _hoisted_2 = { class: "header-messages__counter" }

import { computed, onMounted, ref, watch } from "vue"
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue"
import HeaderMessagesModal from "./HeaderMessagesModal.vue"
import { headerStore } from "@/store/header"
import { rootStore } from "@/store/index"


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderMessagesButton',
  setup(__props) {

const store = headerStore()
const root = rootStore()
const $modal = ref<InstanceType<typeof HeaderMessagesModal> | null>(null)

const count = computed(() => store.unreadMessagesCount)
const hasChatsAccess = computed(() => store.chatsAccess !== false)

const onClick = () => {
	$modal.value?.open()
}

const fetchOnce = () => {
	if (!store.getDialogs?.length) {
		store.fetchDialogs()
	}
}

onMounted(() => {
	if (root.globalJWT) {
		fetchOnce()
		return
	}
	const unwatch = watch(() => root.globalJWT, (token) => {
		if (token) {
			fetchOnce()
			unwatch()
		}
	})
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (hasChatsAccess.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "header-messages__btn",
          title: "Сообщения",
          onClick: onClick
        }, [
          _createVNode(AppIcon, {
            name: "envelope",
            width: "20px",
            height: "20px",
            cursor: "pointer",
            class: "header-messages__icon"
          }),
          _createElementVNode("span", _hoisted_2, _toDisplayString(count.value), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(HeaderMessagesModal, {
      ref_key: "$modal",
      ref: $modal
    }, null, 512)
  ]))
}
}

})